<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>주차서비스</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">주차서비스</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/unpaidinfo" title="주차요금정산">주차요금정산</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">웹 선불권</p>
          <ul class="depth">
            <li><router-link to="/periodinfo" title="정기권">정기권</router-link></li>
            <li><router-link to="/webdiscountuse" title="웹 선불권">웹 선불권</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">웹 선불권 충전</p>
          <ul class="depth">
            <li><router-link to="/webdiscountcharge" title="웹 선불권 충전">웹 선불권 충전</router-link></li>
            <li><router-link to="/webdiscountuse" title="웹 선불권 적용">웹 선불권 적용</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle web">웹 선불권 적용</h3>
        <article class="amountArea type02">
          <div class="txt">
            나의 보유 시간은
            <div class="flex">
              <div class="amount">{{ remainingTime | comma }}</div>
              분 입니다.
            </div>
          </div>
        </article>
        <article>
          <p class="subTitle" style="margin-bottom: 10px">유료 웹 선불권</p>
          <!--table-->
          <div class="table horizontal-table web">
            <table>
              <caption>
                웹 선불권 적용 테이블
              </caption>
              <colgroup>
                <col style="width: 15%; min-width: 125px" />
                <col style="width: 35%" />
                <col style="width: 15%; min-width: 125px" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">차량번호</th>
                  <td>{{ carNo }}</td>
                  <th scope="row">입차시간</th>
                  <td>{{ inDttm }}</td>
                </tr>
                <tr>
                  <th scope="row">주차장 이용시간</th>
                  <td>
                    <strong class="colorType blue">총 이용시간 {{ useTm | comma }} 분</strong>
                  </td>
                  <th scope="row">유료 웹 선불권</th>
                  <td>
                    <div class="dcFlex">
                      <div class="dcInput">
                        <input
                          type="text"
                          maxlength="3"
                          title="유료시간 입력"
                          placeholder="예) 150"
                          :value="selectTime"
                          @input="bindNumber"
                          @keyup.enter="clickApplyBtn()"
                        />
                        <em>분</em>
                      </div>
                    </div>
                    <p class="info">30분 단위로 입력하시기 바랍니다.</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--//table-->
          <!--table-->
          <div class="table horizontal-table mobile">
            <table>
              <caption>
                웹 선불권 적용 테이블
              </caption>
              <colgroup>
                <col style="width: 15%; min-width: 125px" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">차량번호</th>
                  <td>{{ carNo }}</td>
                </tr>
                <tr>
                  <th scope="row">입차시간</th>
                  <td>{{ inDttm }}</td>
                </tr>
                <tr>
                  <th scope="row">주차장 이용시간</th>
                  <td>
                    <strong class="colorType blue">총 이용시간 {{ useTm | comma }} 분</strong>
                  </td>
                </tr>
                <tr>
                  <th scope="row">유료 웹 선불권</th>
                  <td>
                    <div class="dcFlex">
                      <div class="dcInput">
                        <input
                          type="text"
                          maxlength="3"
                          title="유료시간 입력"
                          placeholder="예) 150"
                          :value="selectTime"
                          @input="bindNumber"
                          @keyup.enter="clickApplyBtn()"
                        />
                        <em>분</em>
                      </div>
                    </div>
                    <p class="info">30분 단위로 입력하시기 바랍니다.</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--//table-->
        </article>
        <article v-if="namcheon">
          <p class="subTitle" style="margin-bottom: 10px">무료 웹 선불권</p>
          <!--table-->
          <div class="table horizontal-table">
            <table>
              <caption>
                웹 선불권 적용 테이블
              </caption>
              <colgroup>
                <col style="width: 15%; min-width: 125px" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">현재 무료 적용시간</th>
                  <td>
                    <strong class="colorType blue">{{ freeTm }} 분</strong>
                  </td>
                </tr>
                <tr>
                  <th scope="row">추가 무료 적용시간</th>
                  <td>
                    <div class="flexBtn">
                      최대 &nbsp;<strong class="colorType blue">{{ selectFreeTime }} 분</strong>
                      <div class="btnArea">
                        <button type="button" class="btn sky" :disabled="selectFreeTime == 0" @click="timeBtn()">
                          30분
                        </button>
                        <button type="button" class="btn sky" @click="resetBtn()">초기화</button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--//table-->
        </article>
        <article class="btnArea">
          <button type="button" class="btn gray" @click="$router.go(-1)">목록</button>
          <button type="button" class="btn blue" @click="clickApplyBtn()">적용</button>
        </article>
      </div>
    </section>
    <!-- 알럿 -->
    <alert-match v-show="showModalMsgSuccess">
      <template #content>
        <p>{{ msg }}</p>
        <article class="btnArea">
          <button class="btn blue" @click="CloseBtn">확인</button>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancelBtn"><span class="hidden">닫기</span></button>
      </template>
    </alert-match>
  </main>
</template>

<script>
import AlertMatch from '../../../components/Alert01.vue';

import axios from '../../../util/axios';

export default {
  data() {
    return {
      namcheon: false,
      msg: '',
      showModalMsgSuccess: false,
      returnUrl: false,
      resultOther: 0,
      timeUserInfo: {},
      initData: {},
      useTm: '',
      selectTime: '',
      inOutId: '',
      freeTm: 0,
      orgFreeTime: 0,
      selectFreeTime: 0,
      remainingTime: 0,
      inDttm: '',
      check: false,
    };
  },

  components: {
    AlertMatch,
  },

  created() {
    this.carNo = this.$route.params.carNo;
    if (!this.carNo) {
      this.msg = '잘못된 접근입니다.';
      this.showModalMsgSuccess = true;
      this.returnUrl = true;
      return;
    }
    this.useTm = this.$route.params.useTm;
    this.freeTm = this.$route.params.freeTm;
    this.inOutId = this.$route.params.inOutId;
    this.inDttm = this.$route.params.inDttm;
    this.initView(this.carNo);
  },

  methods: {
    async initView(carNo) {
      const res = await axios('get', '/api/time/init.json', {
        carNo: carNo,
        portalId: this.$store.state.empNo,
        empEsntlId: this.$store.state.empEsntlId,
        inOutId: this.inOutId,
      });

      const data = res.data.result;

      if (!data || data.length < 0) {
        this.timeUserInfo = {};
        this.msg = '잘못된 접근입니다.';
        this.returnUrl = true;
        this.showModalMsgSuccess = true;
        return;
      }

      if (!res.data.result.result) {
        return;
      }

      this.timeUserInfo = data.data;

      this.remainingTime = this.timeUserInfo.remainingTime;

      if (this.timeUserInfo.sectnId == '4') {
        if (this.$store.state.marketYn == 'Y') {
          this.namcheon = true;
          this.selectFreeTime = 120 - this.timeUserInfo.freeTime;
        }
      }
    },

    bindNumber(event) {
      this.selectTime = event.target.value;
      if (Number(this.selectTime) > Number(this.remainingTime)) {
        this.selectTime = this.remainingTime;
      }
    },

    CancelBtn() {
      this.showModalMsgSuccess = false;

      if (this.returnUrl) this.$router.push('/webdiscountuse');
    },

    CloseBtn() {
      this.showModalMsgSuccess = false;

      if (this.returnUrl) this.$router.push('/webdiscountuse');
    },
    async clickApplyBtn() {
      if (this.check) return;
      this.check = true;
      if (
        this.selectTime == '0' ||
        this.selectTime == '00' ||
        this.selectTime == '000' ||
        this.selectTime == '' ||
        Number(this.selectTime) > Number(this.remainingTime)
      ) {
        if (this.orgFreeTime < 0 || this.orgFreeTime == 0) {
          this.selectTime = '';
          this.msg = '할인시간을 확인해주세요.';
          this.showModalMsgSuccess = true;
          return;
        }
      }
      this.resultOther = parseInt(this.selectTime) % 30;

      if (this.resultOther > 0) {
        this.msg = '30분단위로만 가능합니다.';
        this.showModalMsgSuccess = true;
        return;
      }
      if (this.freeTime > this.orgFreeTime) {
        this.freeTime -= this.orgFreeTime;
      }
      const res = await axios('get', '/api/time/receipt.json', {
        carNo: this.carNo,
        freeTime: this.orgFreeTime,
        useTime: this.selectTime,
        inOutId: this.inOutId,
      });

      const resData = res.data.result;

      if (!resData || resData.length === 0) {
        this.msg = '잘못된 접근입니다.';
        this.returnUrl = true;
        this.showModalMsgSuccess = true;

        return;
      } else {
        this.msg = '적용되었습니다.';
        this.showModalMsgSuccess = true;
        this.returnUrl = true;
      }
      this.check = false;
    },
    timeBtn() {
      this.freeTm += 30;
      this.orgFreeTime += 30;
      this.selectFreeTime -= 30;
    },
    resetBtn() {
      this.freeTm -= this.orgFreeTime;
      this.selectFreeTime = 120 - this.timeUserInfo.freeTime;
      this.orgFreeTime = 0;
    },
  },
  watch: {
    selectTime(val) {
      const reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z]/;
      // 한글, 영문 체크
      if (reg.exec(val) !== null) this.selectTime = val.replace(/[^0-9]/g, '');
      // .... 만 입력하게 될 경우 체크
      if (isNaN(parseFloat(val))) this.selectTime = '';
    },
  },
};
</script>

